import * as React from 'react';

const ProfileContext = React.createContext(null);

export type BaseModel = null | {
    email: string;
    firstName: string;
    fiscalCode: string;
    lastName: string;
    oid: string;
};

export const ProfileContextProvider = ({ children }) => {

    const [profile, setProfile] = React.useState<BaseModel>(null);

    return (
        <ProfileContext.Provider value={[profile, setProfile]}>
            {children}
        </ProfileContext.Provider>
    );
};

export const useProfileContext:
    () => [BaseModel, React.Dispatch<React.SetStateAction<BaseModel>>] =
    () => React.useContext(ProfileContext);

